import { render } from "./pca-grid-dictionary.vue?vue&type=template&id=45d1106a"
import script from "./pca-grid-dictionary.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-grid-dictionary.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-grid-dictionary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45d1106a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45d1106a', __exports__)) {
    api.reload('45d1106a', __exports__)
  }
  
  module.hot.accept("./pca-grid-dictionary.vue?vue&type=template&id=45d1106a", () => {
    api.rerender('45d1106a', render)
  })

}


export default __exports__